export default { 
  List: require('./List').default,
  ListProgram: require('./ListProgram').default,
  Update: require('./Update').default,
  Detail: require('./Detail').default,
}